import FoldersModalView from "./folders-modal.html";

angular.module("folders")
    .factory("foldersService", ['$injector', function ($injector) {
        var instance = null;
        function remove() {
            instance = null;
        }
        var service = {
            folders: function (entity_type, entity_type_id, is_public) {
                if (instance != null) return;
                var $uibModal = $injector.get("$uibModal");
                instance = $uibModal.open({
                    animation: true,
                    template: FoldersModalView,
                    controller: 'FoldersListCtrl',
                    size: 'lg',
                    resolve: {
                        entity_type: function () { return entity_type; },
                        entity_type_id: function () { return entity_type_id; },
                        is_public: function () { return is_public; }
                    }
                });
                instance.result.then(function (result) {
                    remove();
                }, function () {
                    remove();
                })
            },
            onClose: function () {
                instance.close();
            }
        };
        return service;
    }])

    .directive('foldersfilesDirective', [function() {
        'use strict';
        return {
            restrict: 'E',
            scope: {
                to: "=",
            },           
            replace: true,
            controller: 'FoldersListCtrl',
            /*link: function (scope, elem, attrs) {
                if (!attrs.entitytype) {
                    throw "Tiene que tener 'entitytype'";
                }
                logService.debug(attrs);
            },*/
            resolve: function (attrs) {
                return {
                    entitytype: function () { return attrs.entity_type; },
                    entitytypeid: function () { return attrs.entity_type_id; }
                }
            },
            template: FoldersModalView,
       };
}]);
    ;